import request from '@/utils/request'

/** 查询web用户信息列表(游客) */
export function webListUserVisitors(data: AnyObject) {
  return request<{
    data: AnyObject[]
    rows: AnyObject[]
  }>({
    url: '/web/listUser',
    method: 'get',
    params: data,
  })
}

/** 查询web 客户端用户信息列表 */
export function webListUser(data: AnyObject) {
  return request<{
    data: AnyObject[]
    rows: AnyObject[]
  }>({
    url: '/client/web/user/list',
    method: 'get',
    params: data,
  })
}

/** 获取web 客户端用户信息详细信息 */
export function webListUserDetail(id: string) {
  return request<{
    data: AnyObject
  }>({
    url: `/client/web/user/${id}`,
    method: 'get',
  })
}
//
